import { ReactNode, createContext, useContext, useState } from "react";
import BanModal from "./BanModal";
import ActivateModal from "./ActivateModal";
import { IFleetModel } from "models/fleetModel";
import DeleteModal from "./DeleteModal";

interface IFleetModelAlertProps {
  showBan: (fleetModel: IFleetModel) => void;
  showActivate: (fleetModel: IFleetModel) => void;
  showDelete: (fleetModel: IFleetModel) => void;
}

export const FleetModelAlertContext = createContext<IFleetModelAlertProps>(
  {} as IFleetModelAlertProps
);

export const useFleetModelAlertContext = () =>
  useContext<IFleetModelAlertProps>(FleetModelAlertContext);

interface IOpen {
  open: boolean;
  fleetModel: IFleetModel | null;
}

export function FleetModelAlertContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [openBan, setOpenBan] = useState<IOpen>({
    open: false,
    fleetModel: null,
  });
  const [openActivate, setOpenActivate] = useState<IOpen>({
    open: false,
    fleetModel: null,
  });
  const [openDelete, setOpenDelete] = useState<IOpen>({
    open: false,
    fleetModel: null,
  });

  const showBan = (fleetModel: IFleetModel) =>
    setOpenBan({ open: true, fleetModel });
  const showActivate = (fleetModel: IFleetModel) =>
    setOpenActivate({ open: true, fleetModel });
  const showDelete = (fleetModel: IFleetModel) =>
    setOpenDelete({ open: true, fleetModel });
  const handleCloseBan = () => setOpenBan({ open: false, fleetModel: null });
  const handleCloseActivate = () =>
    setOpenActivate({ open: false, fleetModel: null });
  const handleCloseDelete = () =>
    setOpenDelete({ open: false, fleetModel: null });

  return (
    <FleetModelAlertContext.Provider
      value={{
        showActivate,
        showBan,
        showDelete,
      }}
    >
      {openBan.fleetModel && (
        <BanModal
          open={openBan.open}
          fleetModel={openBan.fleetModel}
          handleClose={handleCloseBan}
        />
      )}

      {openActivate.fleetModel && (
        <ActivateModal
          open={openActivate.open}
          fleetModel={openActivate.fleetModel}
          handleClose={handleCloseActivate}
        />
      )}

      {openDelete.fleetModel && (
        <DeleteModal
          open={openDelete.open}
          fleetModel={openDelete.fleetModel}
          handleClose={handleCloseDelete}
        />
      )}

      {children}
    </FleetModelAlertContext.Provider>
  );
}
